export const documentaryList = [
  {
    id: "d-01",
    title: "大地呼吸",
    category: "documentary",
    year: "2023",
    region: "中国大陆",
    director: "李长风",
    cast: "本片无主要演员",
    duration: "52 分钟",
    rating: 9.2,
    views: 384000,
    updatedAt: "2024-10-12",
    tags: ["自然", "生态", "人文"],
    summary: "跟随四位生态观察员，记录一年四季里土地最细微的变化。",
    description:
      "摄制组用一年时间驻守在高山草甸、湿地与荒漠边缘，跟随四位长期从事生态监测的观察员，记录土壤、植被与候鸟的细微变化。没有解说词的强引导，只有风声、足音和远处的水流。这是一部需要静下心来看的纪录片。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20poster%20artwork%20of%20a%20vast%20green%20highland%20meadow%20under%20dramatic%20clouds%20at%20golden%20hour%2C%20tiny%20human%20figure%20in%20the%20distance%2C%20grainy%20film%20texture%2C%20earthy%20natural%20palette%2C%20no%20text&width=600&height=900&seq=cov-earth-breathing&orientation=portrait",
  },
  {
    id: "d-02",
    title: "手艺人：最后一炉",
    category: "documentary",
    year: "2022",
    region: "中国大陆",
    director: "吴砚",
    cast: "本片无主要演员",
    duration: "78 分钟",
    rating: 8.9,
    views: 216000,
    updatedAt: "2024-09-08",
    tags: ["人文", "手艺", "匠人"],
    summary: "一位烧了五十年瓷的老人，决定在关窑前完成最后一件作品。",
    description:
      "窑口即将被拆除，七十三岁的老师傅要在最后一次开窑前，完成一件从未成功过的釉色。纪录片拍下了选土、拉坯、上釉、控温的每一个环节，也拍下了他的三个学徒陆续离开的理由。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20poster%20artwork%20of%20hands%20shaping%20clay%20on%20a%20potter%20wheel%20in%20a%20dim%20workshop%20lit%20by%20kiln%20fire%20glow%2C%20dust%20in%20the%20air%2C%20grainy%20texture%2C%20warm%20earthy%20palette%2C%20no%20text&width=600&height=900&seq=cov-last-kiln&orientation=portrait",
  },
  {
    id: "d-03",
    title: "河流的记忆",
    category: "documentary",
    year: "2021",
    region: "欧美",
    director: "Camille Roux",
    cast: "本片无主要演员",
    duration: "64 分钟",
    rating: 8.4,
    views: 132000,
    updatedAt: "2024-08-14",
    tags: ["自然", "地理", "人文"],
    summary: "一条被改道三次的河流，如何改变了沿岸五座城市的命运。",
    description:
      "从源头到入海口，摄制组沿河而下，采访渔民、船工、水文工程师与在老桥上卖花的老人。河流的每一次改道，都在城市的版图上留下痕迹。影片用航拍与口述史交替，讲述水与人之间漫长的博弈。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20poster%20artwork%20of%20a%20wide%20river%20bending%20through%20a%20misty%20old%20town%20at%20sunrise%20with%20a%20stone%20bridge%20silhouette%2C%20soft%20golden%20reflections%2C%20grainy%20film%20texture%2C%20no%20text&width=600&height=900&seq=cov-river-memory&orientation=portrait",
  },
  {
    id: "d-04",
    title: "城市夜行者",
    category: "documentary",
    year: "2024",
    region: "日本",
    director: "小林澄人",
    cast: "本片无主要演员",
    duration: "88 分钟",
    rating: 8.6,
    views: 205000,
    updatedAt: "2024-11-06",
    tags: ["社会", "都市", "人文"],
    summary: "凌晨一点到五点，这座城市属于另一群人。",
    description:
      "深夜的便利店、24 小时洗衣房、末班车后的站台和正在清扫街道的工人，构成了城市的另一半。纪录片跟随六位夜班工作者，记录他们与这座城市之间安静而真实的相处方式。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20poster%20artwork%20of%20an%20empty%20neon%20lit%20city%20street%20at%203am%20with%20wet%20asphalt%20reflections%20and%20a%20lone%20silhouette%20walking%2C%20amber%20glow%2C%20grainy%20film%20texture%2C%20no%20text&width=600&height=900&seq=cov-night-walkers&orientation=portrait",
  },
  {
    id: "d-05",
    title: "山那边的课堂",
    category: "documentary",
    year: "2023",
    region: "中国大陆",
    director: "何守义",
    cast: "本片无主要演员",
    duration: "72 分钟",
    rating: 9.0,
    views: 298000,
    updatedAt: "2024-10-26",
    tags: ["教育", "纪实", "人文"],
    summary: "一所只有十一个学生的村小，和一位教了三十年书的老师。",
    description:
      "山路要走两个小时，冬天会结冰。十一个孩子，一位老师，一间漏风的教室。纪录片不渲染苦难，只记录课堂上的朗读声、午饭的蒸汽和放学后孩子们一路小跑的背影。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20poster%20artwork%20of%20a%20small%20rural%20classroom%20with%20wooden%20desks%20and%20soft%20morning%20light%20through%20a%20window%2C%20mountain%20silhouette%20outside%2C%20grainy%20film%20texture%2C%20warm%20muted%20palette%2C%20no%20text&width=600&height=900&seq=cov-classroom-beyond&orientation=portrait",
  },
  {
    id: "d-06",
    title: "追光者",
    category: "documentary",
    year: "2020",
    region: "欧美",
    director: "Owen Blake",
    cast: "本片无主要演员",
    duration: "95 分钟",
    rating: 8.3,
    views: 118000,
    updatedAt: "2024-05-16",
    tags: ["科学", "天文", "纪实"],
    summary: "一群在天文台守了二十年的观测者，等待一次可能永远不会到来的信号。",
    description:
      "山顶的天文台常年大雪封路，观测团队每次驻守三个月。他们的工作枯燥、重复，却在某个凌晨收到了无法解释的数据波动。纪录片同时拍下了科研的浪漫与残酷。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20poster%20artwork%20of%20a%20lone%20observatory%20dome%20on%20a%20snowy%20mountain%20ridge%20under%20a%20deep%20starry%20sky%20with%20faint%20amber%20horizon%20glow%2C%20grainy%20film%20texture%2C%20no%20text&width=600&height=900&seq=cov-light-chaser&orientation=portrait",
  },
];